import type { AllowBlockState, PolicyRule } from '../types';
import {
  addRowToList,
  removeRowById,
  replaceRowInList,
} from '@/components/editable-row-table/lib/listHelpers';

/** Policy rule lists use the same shape as {@link EditableRow}; delegate to shared list helpers. */
export const addRule = addRowToList as (
  list: PolicyRule[],
  rule: PolicyRule
) => PolicyRule[];

export const updateRule = replaceRowInList as (
  list: PolicyRule[],
  id: string,
  next: PolicyRule
) => PolicyRule[];

export const removeRule = removeRowById as (
  list: PolicyRule[],
  id: string
) => PolicyRule[];

/** After save, drop soft-deleted rows so UI matches persisted rules. */
export function dropPendingDeletes(state: AllowBlockState): AllowBlockState {
  return {
    ...state,
    allowed: state.allowed.filter(r => !r.pendingDelete),
    blocked: state.blocked.filter(r => !r.pendingDelete),
  };
}
